/* @flow */

import { normalizeEvent } from '@e180/domain/lib/event/util';

import * as types from './eventActionTypes';
import { patchEntities } from 'src/shared/domain/base/action/entityActions';
import {
  forStartupParam,
  eventEndpoint,
  groupBraindateAvailablePeriods,
  groupBraindateTimeSlotsSuggestions,
} from 'src/shared/app/base/settings/endpointSettings';
import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';

import type { TimeSlot } from '@e180/domain/lib/base/type';

// Single event

export function fetchEvent(id: number | string, data?: Object) {
  return (dispatch: any, { get }: Object) => {
    dispatch(fetchEventRequest());

    return get(eventEndpoint(id), data)
      .then(parseResponse)
      .then((json) => {
        const normalizedData = normalizeEvent(json);
        const { entities, result } = normalizedData;

        dispatch(patchEntities(entities));
        // $FlowIssue
        dispatch(fetchEventSuccess(result));

        return json;
      })
      .catch((exception) => {
        dispatch(fetchEventFailure(exception));

        throw exception;
      });
  };
}

export function fetchEventRequest() {
  return {
    type: types.FETCH_EVENT_REQUEST,
  };
}

export function fetchEventSuccess(result: number) {
  return {
    type: types.FETCH_EVENT_SUCCESS,
    result,
  };
}

export function fetchEventFailure(exception: Error) {
  return {
    type: types.FETCH_EVENT_FAILURE,
    exception,
  };
}

// Reset

export function resetEvent() {
  return {
    type: types.RESET_EVENT,
  };
}

// Group braindate time slots suggestions

export function fetchGroupBraindateTimeSlotsSuggestions(
  id: number,
  params?: Object,
) {
  return (dispatch: any, { get }: Object) => {
    dispatch(fetchGroupBraindateTimeSlotsSuggestionsRequest());

    return get(groupBraindateTimeSlotsSuggestions(id), params)
      .then(parseResponse)
      .then((json) => {
        dispatch(fetchGroupBraindateTimeSlotsSuggestionsSuccess(json, id));
      })
      .catch((e) => {
        dispatch(fetchGroupBraindateTimeSlotsSuggestionsFailure(e));

        throw e;
      });
  };
}

export function fetchGroupBraindateTimeSlotsSuggestionsRequest() {
  return {
    type: types.FETCH_GROUP_BRAINDATE_TIME_SLOTS_SUGGESTIONS_REQUEST,
  };
}

export function fetchGroupBraindateTimeSlotsSuggestionsSuccess(
  result: Array<TimeSlot>,
  eventId: number,
) {
  return {
    type: types.FETCH_GROUP_BRAINDATE_TIME_SLOTS_SUGGESTIONS_SUCCESS,
    result,
    eventId,
  };
}

export function fetchGroupBraindateTimeSlotsSuggestionsFailure(
  exception: Error,
) {
  return {
    type: types.FETCH_GROUP_BRAINDATE_TIME_SLOTS_SUGGESTIONS_FAILURE,
    exception,
  };
}

// Group braindate available periods

export function fetchGroupBraindateAvailablePeriods(id: number) {
  return (dispatch: any, { get }: Object) => {
    dispatch(fetchGroupBraindateAvailablePeriodsRequest());

    return get(groupBraindateAvailablePeriods(id))
      .then(parseResponse)
      .then((json) => {
        dispatch(fetchGroupBraindateAvailablePeriodsSuccess(json, id));
      })
      .catch((e) => {
        {
          dispatch(fetchGroupBraindateAvailablePeriodsFailure(e));

          throw e;
        }
      });
  };
}

export function fetchGroupBraindateAvailablePeriodsRequest() {
  return {
    type: types.FETCH_GROUP_BRAINDATE_AVAILABLE_PERIODS_REQUEST,
  };
}

export function fetchGroupBraindateAvailablePeriodsSuccess(
  result: Array<TimeSlot>,
  eventId: number,
) {
  return {
    type: types.FETCH_GROUP_BRAINDATE_AVAILABLE_PERIODS_SUCCESS,
    result,
    eventId,
  };
}

export function fetchGroupBraindateAvailablePeriodsFailure(exception: Error) {
  return {
    type: types.FETCH_GROUP_BRAINDATE_AVAILABLE_PERIODS_FAILURE,
    exception,
  };
}

// Public

export function fetchPublicEvent(id: number | string) {
  return (dispatch: any, { get }: Object) => {
    dispatch(fetchPublicEventRequest());

    return get(eventEndpoint(id), { [forStartupParam]: true })
      .then(parseResponse)
      .then((json) => {
        dispatch(fetchPublicEventSuccess(json.id, json));

        return json;
      })
      .catch((e) => {
        dispatch(fetchPublicEventFailure(e));

        throw e;
      });
  };
}

export function fetchPublicEventRequest() {
  return {
    type: types.FETCH_PUBLIC_EVENT_REQUEST,
  };
}

export function fetchPublicEventSuccess(result: number, entities: Object) {
  return {
    type: types.FETCH_PUBLIC_EVENT_SUCCESS,
    result,
    entities,
  };
}

export function fetchPublicEventFailure(exception: Error) {
  return {
    type: types.FETCH_PUBLIC_EVENT_FAILURE,
    exception,
  };
}
